module.exports = __webpack_public_path__ + "static/img/rank_126.49c015e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_126.png
// module id = GZiw
// module chunks = 1